// AGGR extra ISO_A2 CODE
export default {
  UK: 'GB',
  GP: 'FR',
  MQ: 'FR',
};
